import {Header} from "../components/Header";
import {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import {Footer} from "../components/Footer";
import {isPc, savePageVisit} from "../static/js/common";


const Menu = ({item, index, isActive, setMenu}) => {
  return (
    <div
      style={{fontSize: isPc ? '6vw' : '20vw'}}
      className={`white bold bebas-kai ${isActive ? 'active-menu' : ''}`}
      onMouseEnter={() => setMenu(item?.title)}
      onMouseLeave={() => setMenu('')}
      onClick={item?.onClick}
    >
      {item?.title}
    </div>
  )
}

export const Nav = ({}) => {

  const navigate = useNavigate();

  const [menu, setMenu] = useState('');

  const menus = [
    {
      title: 'WORKS',
      onClick: () => navigate('/works')
    },
    {
      title: 'SERVICE',
      onClick: () => navigate('/service')
    },
    {
      title: 'CONTACT',
      onClick: () => navigate('/contact')
    },
    {
      title: 'CAREERS',
      onClick: () => navigate('/career')
    },
  ]

  useEffect(() => {
    savePageVisit('네비게이션')
    window.scroll(0, 0)
  }, []);

  return (
    <div>
      <Header rightCancel/>
      {isPc ?
        <div className={'relative'} style={{marginTop: 80}}>
          <img className={'width-100'} src={require('../assets/images/nav_bg.png')}/>
          <div className={'absolute'} style={{top: '11vw', left: '63vw'}}>
            {menus?.map((item, index) => {
              const isActive = menu === item?.title
              return <Menu item={item} index={index} isActive={isActive} setMenu={setMenu}/>
            })}
          </div>
          <div className={'absolute'} style={{left: '10vw', top: '16vw'}}>
            <div className={`white bold bebas-kai`} style={{fontSize: '14vw'}}>{menu}</div>
          </div>
        </div>
        :
        <div className={'black-bg width-100-vw'} style={{marginTop: 80}}>
          <div className={'flex-center flex-column'}>
            {menus?.map((item, index) => {
              const isActive = menu === item?.title
              return <Menu item={item} index={index} isActive={isActive} setMenu={() => {}}/>
            })}
          </div>
        </div>
      }
      <Footer/>
    </div>
  )
}
